import * as $ from "jquery";
import tracking from '../../utils/tracking';

export default class TemplateSearchBar {
  componentRoot: JQuery<HTMLElement>;
  params: any;
  searchForm: JQuery<HTMLElement>;
  searchInput: JQuery<HTMLElement>;
  submitSearch: JQuery<HTMLElement>;
  categories: JQuery<HTMLElement>;
  backButton: JQuery<HTMLElement>;

  constructor(componentRoot: HTMLElement, params: any) {
    this.componentRoot = $(componentRoot);
    this.params = params;
    this.searchForm = $('#search-form', this.componentRoot);
    this.searchInput = $('#search-input', this.componentRoot);
    this.submitSearch = $('#search-submit', this.componentRoot);
    this.categories = $(".component--category-selector__link", this.componentRoot);
    this.backButton = $(".back-button", this.componentRoot);
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const { analyticsDataAttribute } = this.params;

    // only bind event handlers if rendered outside of search page
    if(!window.location.href.includes(this.params.searchBaseUrl)) {
      this.searchForm.on('submit', event => {
        event.preventDefault();


        const eventName = this.searchForm.data(analyticsDataAttribute) as unknown as string;
        tracking.trackEvent(this.getEventName(eventName), { "searchTerm": this.searchInput.val() });
        this.navigateToSearchPage();
      });

      this.submitSearch.on('click', event => {
        event.preventDefault();

        const eventName = this.submitSearch.data(analyticsDataAttribute) as unknown as string;
        tracking.trackEvent(this.getEventName(eventName), { "searchTerm": this.searchInput.val() });
        this.navigateToSearchPage();
      });
    }

    this.categories.on('click', event => {
      const eventName = this.categories.data(analyticsDataAttribute) as unknown as string;
      tracking.trackEvent(this.getEventName(eventName), { "selectedCategory": event.target.innerText });
    });

    this.backButton.on('click', () => {
      const eventName = this.backButton.data(analyticsDataAttribute) as unknown as string;
      tracking.trackEvent(this.getEventName(eventName));
    });
  }

  navigateToSearchPage() {
    const searchTerm = this.htmlEscape(this.searchInput.val() as string);
    window.location.href = `${this.params.searchBaseUrl}?term=${encodeURI(searchTerm)}`;
  }

  htmlEscape(str: string) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  getEventName(eventName: string) {
    return `${this.params.prefix}.${eventName}`
  }
}
